export default {"src":"/_next/static/media/GlobeFlag.5a1335b1.svg","height":20,"width":28};